import { CSSObject } from '@emotion/react'

const postHeights: Record<string, string> = {
  square: '629px',
  landscape: '450px',
  portrait: '724px',
}

const getBaseStyles = (
  isExpanded: boolean,
  height: number,
  orientation: string,
  notCropped: boolean
): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  width: isExpanded ? 900 : 484,
  minHeight: notCropped ? postHeights[orientation] : postHeights['square'],
  height: isExpanded ? 'unset' : height,
})

const getActiveViewport = (): CSSObject => ({
  position: 'relative',
  top: '55px',
  zIndex: 10000,
})

const arrowHeights: Record<string, string> = {
  square: '259px',
  landscape: '170px',
  portrait: '306px',
}

const getArrowHeight = (
  notCropped: boolean,
  orientation: string
): CSSObject => ({
  top: notCropped ? arrowHeights[orientation] : arrowHeights['square'],
})

const getViewport = (
  readOnly: boolean,
  notCropped: boolean,
  height: number
): CSSObject => ({
  top: readOnly ? '107px' : '89px',
  position: 'absolute',
  height: notCropped ? `${height}px` : '375px',
  width: '375px',
  overflow: 'hidden',
})

const getSection = (): CSSObject => ({
  top: '-55px',
})

const styles = {
  getActiveViewport,
  getBaseStyles,
  getArrowHeight,
  getViewport,
  getSection,
}

export { styles }
